import { EnvNames } from "./interface";
import { getOsgBrowserCompassByKey } from "@osgfe/web-compass";

export const envList = [
  {
    label: "开发",
    value: EnvNames.Development,
    desc: "Dev",
    class: "mc-test-env",
  },
  {
    label: "线下",
    value: EnvNames.Test,
    desc: "Test",
    class: "mc-test-env",
  },
  {
    label: "预发",
    value: EnvNames.Staging,
    desc: "Staging",
    class: "mc-st-env",
  },
  {
    label: "线上",
    value: EnvNames.Production,
    desc: "Prod",
    class: "mc-prod-env",
  },
];

export const urlList = {
  jiemo: {
    test: getOsgBrowserCompassByKey({ key: "opcenterKeemartHost", env: "test", needProtocol: true }),
    production: getOsgBrowserCompassByKey({ key: "opcenterKeemartHost", env: "production", needProtocol: true }),
  },
  rss: {
    test: getOsgBrowserCompassByKey({ key: "courierKeemartHost", env: "test", needProtocol: true }),
    production: getOsgBrowserCompassByKey({ key: "courierKeemartHost", env: "production", needProtocol: true }),
  },
  vss: {
    test: getOsgBrowserCompassByKey({ key: "partnerKeemartHost", env: "test", needProtocol: true }),
    production: getOsgBrowserCompassByKey({ key: "partnerKeemartHost", env: "production", needProtocol: true }),
  },
  lps: {
    test: getOsgBrowserCompassByKey({ key: "logisticsKeemartHost", env: "test", needProtocol: true }),
    production: getOsgBrowserCompassByKey({ key: "logisticsKeemartHost", env: "production", needProtocol: true }),
  },
};
